import { CBox } from '@/pages/__styled'
import React from 'react'
import SVG from 'react-inlinesvg'
import { SVGS } from '@/assets/svgs'
import { Typography } from '@mui/material'
import colors from '@/styles/colors'
import { Subtitles } from '@mui/icons-material'

export interface NoDataPlaceholderProps {
  icon: string
  title: string
  subTitle: string
  iconTintColor?: string
}

const NoDataPlaceholder = ({
  icon,
  title,
  subTitle,
  iconTintColor = '#6366f1',
}: NoDataPlaceholderProps) => {
  return (
    <CBox
      sx={{
        alignItems: 'center',
        justifyContent: 'center',
        padding: '60px 40px',
        borderRadius: '20px',
        background: '#ffffff',
        boxShadow: '0 4px 16px rgba(15, 23, 42, 0.06), 0 1px 3px rgba(15, 23, 42, 0.04)',
        maxWidth: '480px',
        margin: '0 auto',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: '0 8px 28px rgba(15, 23, 42, 0.1), 0 2px 6px rgba(15, 23, 42, 0.06)',
        },
      }}
    >
      {/* Icon Container */}
      <CBox
        sx={{
          width: '96px',
          height: '96px',
          borderRadius: '24px',
          background: `linear-gradient(135deg, ${iconTintColor}15 0%, ${iconTintColor}08 100%)`,
          border: `2px solid ${iconTintColor}20`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: '24px',
          boxShadow: `0 4px 16px ${iconTintColor}12`,
        }}
      >
        <SVG width={'48px'} height={'48px'} src={icon} color={iconTintColor} />
      </CBox>

      {/* Title */}
      <Typography
        sx={{
          fontSize: '20px',
          fontWeight: 700,
          color: '#0f172a',
          textAlign: 'center',
          letterSpacing: '-0.02em',
          marginBottom: '8px',
        }}
      >
        {title}
      </Typography>

      {/* Subtitle */}
      {subTitle.length > 0 && (
        <Typography
          sx={{
            fontSize: '15px',
            fontWeight: 500,
            color: '#64748b',
            textAlign: 'center',
            lineHeight: 1.6,
            maxWidth: '360px',
          }}
        >
          {subTitle}
        </Typography>
      )}
    </CBox>
  )
}

export default NoDataPlaceholder
